import { useNavigate, useParams } from "react-router-dom";
import ApiStatus from "../../components/ApiStatus";
import Button from "../../components/Common/Button";
import Divider from "../../components/Common/Divider";
import Heading from "../../components/Common/Heading";
import Section from "../../components/Common/Section";
import FormActions from "../../components/Form/FormActions";
import FormContainer from "../../components/Form/FormContainer";
import getApiExceptionObjectFromAxiosError from "../../utils/ProcessException";
import { useDeactivateIzobrazevanje, useFetchIzobrazevanjeDetail } from "./IzobrazevanjeHooks";
import styled from "styled-components";
import { IzobrazevanjeJavnoDetailType } from "../../types/Izobrazevanje/IzobrazevanjeJavnoDetailType";
import IzobrazevanjeJavnoDetailForm from "./IzobrazevanjeJavnoDetailForm";
import Modal from "../../components/Common/Modal";
import { useState } from "react";
import { IzobrazevanjeDetailType } from "../../types/Izobrazevanje/IzobrazevanjeDetailType";

const StyledIzobrazevanjeJavnoDetailForm = styled.div`
    p{
        margin: 0 0 1rem 0;
    }
    .upper{
        display: flex;
        gap: 2rem;
    }
    .right {
        width: 30%;
    }
    .heading {
        margin-top: 2rem;
        margin-bottom: 1rem;
        font-size: 1.7rem;
    }
    .available{
        margin-bottom: 1rem;
        font-weight: 500;
    }
    .card{
        margin-bottom: 1rem;
    }
    @media (max-width: 650px) {
        .upper{
            flex-direction: column;
            gap: 0;
        }
        .right {
            width: 100%;
            margin-bottom: 1rem;
        }
    }
`

type IzobrazevanjeJavnoDetailArgs = {
    izobrazevanjeData: IzobrazevanjeDetailType;
}

const IzobrazevanjeJavnoDetail = ({ izobrazevanjeData }: IzobrazevanjeJavnoDetailArgs) => {
    const nav = useNavigate();
    const { izobrazevanjeId } = useParams();
    if (!izobrazevanjeId)
        throw Error("Manjka parameter izobrazevanjeId");

    const izobrazevanjeIdInt = parseInt(izobrazevanjeId);
    //const { data: izobrazevanjeData, status: izobrazevanjeStatus, isSuccess: izobrazevanjeIsSuccess, error: izobrazevanjeError } = useFetchIzobrazevanjeDetail<IzobrazevanjeJavnoDetailType>(izobrazevanjeIdInt);
    //const { data: izobrazevanjeData, status: izobrazevanjeStatus, isSuccess: izobrazevanjeIsSuccess, error: izobrazevanjeError } = useFetchIzobrazevanjeDetail(izobrazevanjeIdInt);
    const deactivateIzobrazevanjeMutatied = useDeactivateIzobrazevanje();
    const [showDeactivateModal, setShowDeactivateModal] = useState(false);

    const onDeactivate: React.MouseEventHandler<HTMLButtonElement> = async (e) => {
        e.preventDefault();
        deactivateIzobrazevanjeMutatied.mutate(izobrazevanjeIdInt)
    }

    return (
        <Section>
            <Heading>Podrobnosti izobraževanja
                <Divider />
            </Heading>
            {izobrazevanjeData &&
                <StyledIzobrazevanjeJavnoDetailForm>
                    <FormContainer>
                        <div className="upper">
                            <IzobrazevanjeJavnoDetailForm izobrazevanje={izobrazevanjeData}></IzobrazevanjeJavnoDetailForm>
                        </div>
                        {/* <Button startIcon="arrow_back_ios" onClick={() => nav(izobrazevanjeData.vrsta === IzobrazevanjeVrsta.Javno ? '/izobrazevanje/javno-list' : '/izobrazevanje/list')}> */}
                        <FormActions>
                            <Button startIcon="arrow_back_ios" onClick={() => nav('/izobrazevanje/javno-list')}>
                                Nazaj na seznam
                            </Button>
                            <Button onClick={() => setShowDeactivateModal(true)} tertiary>Deaktiviraj</Button>
                        </FormActions>
                    </FormContainer>
                </StyledIzobrazevanjeJavnoDetailForm>
            }
            <Modal
                    visible={showDeactivateModal}
                    message="Ali ste prepričani da želite deaktivirati to izobraževanje?"
                    actionMessage="Deaktiviraj"
                    actionIcon='toggle off'
                    onCancel={() => setShowDeactivateModal(false)}
                    onConfirm={onDeactivate}
                />
        </Section>
    );
}

export default IzobrazevanjeJavnoDetail;